// @ts-nocheck
export var LcdStatusMode;
(function (LcdStatusMode) {
    LcdStatusMode[LcdStatusMode["InHBlank"] = 0] = "InHBlank";
    LcdStatusMode[LcdStatusMode["InVBlank"] = 1] = "InVBlank";
    LcdStatusMode[LcdStatusMode["SearchingOAM"] = 2] = "SearchingOAM";
    LcdStatusMode[LcdStatusMode["TransferringDataToLCD"] = 3] = "TransferringDataToLCD";
})(LcdStatusMode || (LcdStatusMode = {}));
//# sourceMappingURL=lcd-status-mode.enum.js.map